import { Admin, Resource, ListGuesser, fetchUtils } from "react-admin";
import simpleRestProvider from 'ra-data-simple-rest';
import authProvider from "../authProvider";
import { ShowMSG } from "../message/show";


const httpClient = (url: string, options: fetchUtils.Options = {}) => {
    const customHeaders = (options.headers ||
        new Headers({
            Accept: 'application/json',
        })) as Headers;
    // add your own headers here
    customHeaders.set('Authorization', 'Bearer ${token}');
    options.headers = customHeaders;
    return fetchUtils.fetchJson(url, options);
};

const APP_API: string = process.env.REACT_APP_API_URL ?? ''

const dataProvider = simpleRestProvider(APP_API, httpClient);

const App = () => (
    <Admin authProvider={authProvider} dataProvider={dataProvider} >
        <Resource name="messages" list={ListGuesser} show={ShowMSG} />
        <Resource name="comments" list={ListGuesser} />
    </Admin>
);

export default App;